import styled from 'styled-components';

export const AppointmentWrapper = styled.div<{ color?: string }>`
  div {
    color: ${(props) => props.color ?? props.theme.palette.text.primary};
  }
`;
